<template>
	<TheHeader></TheHeader>
	
	<div class="container-fluid">
		<div class="container">
			<form name="form">
				<div class="contain row">
					<TheSidebar></TheSidebar>
					
					<ReportJournal :identifier="identifier" :reportId="reportId" v-if="reportId == 1 || reportId == 2"></ReportJournal>
					
					<ReportIntercompanyElimination :identifier="identifier" :reportId="reportId" v-if="reportId == 3"></ReportIntercompanyElimination>

					<TheFooter></TheFooter>
				</div>
			</form>
		</div>
	</div>

</template>

<script lang="ts">
	import {defineComponent} from "vue";
	import store from "@/store";
	import {useRoute} from "vue-router";
	
	import TheHeader from "@/components/TheHeader.vue";
	import TheFooter from "@/components/TheFooter.vue";
	import TheSidebar from "@/components/TheSidebar.vue";
	
	import ReportJournal from "@/views/reporting/ReportJournal.vue";
	import ReportIntercompanyElimination from "@/views/reporting/ReportIntercompanyElimination.vue";
	
	export default defineComponent({
		mixins: [],
		components: {
			TheHeader,
			TheFooter,
			TheSidebar,
			ReportJournal,
			ReportIntercompanyElimination
		},
		data() {
			return {
				pageError: (store.getters.error == undefined ? '' : store.getters.error),
				identifier: useRoute().params.id,
				reportId: useRoute().params.reportId,
				isLoading: false,
				isPageLoading: false,
			}
		},
	});
</script>
